import React from 'react';
import ObjectCardContainer from "../common/ObjectCard/ObjectCardContainer";


const AccessRight = (props) => {
    const {objects} = props

    return (
        <div className="main">
            <div className="container-fluid">
                <div className="row cards-object row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-3">
                    {objects && Object.keys(objects).map(object => <ObjectCardContainer
                            key={object} {...objects[object]}>
                            <div className="access">
                                <div className="access-role">
                                <span className="access-role__title">
                                    Доступ к объектам:
                                </span>
                                    <span className="access-role__item">
                                    Соловьев Алексей
                                </span>
                                </div>
                                <div className="access-role ">
                                <span className="access-role__title">
                                    Доступ к счетам:
                                </span>
                                    <span className="access-role__item">
                                    Соловьев Алексей,
                                    Соловьев Алексей,
                                    Соловьев Алексей
                                </span>
                                </div>
                            </div>
                        </ObjectCardContainer>
                    )}
                </div>
            </div>
        </div>
    );
};


export default AccessRight;